import { makeStyles } from '@rbx/ui';
import { maxWidth as landingMaxWidth } from '@modules/layout/Landing';
import { AppBannerVariant } from './AppBanner';
import { appMain } from '../constants/layoutConstants';

type useStylesProps = { backgroundUrl: string; variant: AppBannerVariant };

const useAppBannerStyles = makeStyles<useStylesProps>()((theme, props) => ({
  container: {
    backgroundImage: `url("${props.backgroundUrl}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  textContainer: {
    width: '100%',
    maxWidth: props.variant === 'primary' ? landingMaxWidth : appMain.maxWidth,
    // align with AppMain.styles
    margin: theme.spacing(...appMain.spacing.default),
    marginTop: 64,
    marginBottom: 64,
    [theme.breakpoints.down('XLarge')]: {
      margin: theme.spacing(...appMain.spacing.lg),
      marginTop: 64,
      marginBottom: 64,
    },
    [theme.breakpoints.down('Large')]: {
      margin: theme.spacing(...appMain.spacing.md),
      marginTop: 48,
      marginBottom: 48,
    },
  },
}));
export default useAppBannerStyles;
